import { render, staticRenderFns } from "./EmrDrugNoneDrugOPD.vue?vue&type=template&id=20ef4f28&"
import script from "./EmrDrugNoneDrugOPD.vue?vue&type=script&lang=js&"
export * from "./EmrDrugNoneDrugOPD.vue?vue&type=script&lang=js&"
import style0 from "./EmrDrugNoneDrugOPD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports